"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperatorAttendanceColumnFullWidthProps = exports.OperatorAttendanceColumnProps = void 0;
const constants_1 = require("utils/constants");
const OperatorAttendanceColumnProps = [
    {
        show: true,
        width: '225',
        field: 'contractor_name',
        title: 'Contractor',
        filterable: false,
        sortable: false,
    },
    {
        show: true,
        title: 'Area',
        sortable: false,
        width: '200',
        field: 'area_name',
        filterable: false,
    },
    {
        show: true,
        field: 'no',
        title: 'No',
        width: '80',
        sortable: false,
        filterable: false,
    },
    {
        show: true,
        width: '150',
        title: 'Seam',
        sortable: false,
        field: 'seam_name',
        filterable: false,
    },
    {
        show: true,
        width: '150',
        sortable: false,
        filterable: false,
        field: 'excavator_no',
        title: 'Excavator',
    },
    {
        show: true,
        width: '400',
        sortable: false,
        filterable: false,
        field: 'dump_truck',
        title: 'Dump Truck',
    },
    {
        show: true,
        width: '220',
        sortable: false,
        filterable: false,
        field: 'modified_date',
        title: 'Modified Date',
        format: `${constants_1.formatGridDate.ddMMYYYY} ${constants_1.formatGridDate.hhMM}`
    },
    {
        show: true,
        width: '180',
        sortable: false,
        filterable: false,
        field: 'modified_by',
        title: 'Modified By',
    },
];
exports.OperatorAttendanceColumnProps = OperatorAttendanceColumnProps;
const OperatorAttendanceColumnFullWidthProps = [
    {
        show: true,
        width: 'auto',
        field: 'contractor_name',
        title: 'Contractor',
        filterable: false,
        sortable: false,
    },
    {
        show: true,
        title: 'Area',
        sortable: false,
        width: 'auto',
        field: 'area_name',
        filterable: false,
    },
    {
        show: true,
        field: 'no',
        title: 'No',
        width: '80',
        sortable: false,
        filterable: false,
    },
    {
        show: true,
        width: 'auto',
        title: 'Seam',
        sortable: false,
        field: 'seam_name',
        filterable: false,
    },
    {
        show: true,
        width: 'auto',
        sortable: false,
        filterable: false,
        field: 'excavator_no',
        title: 'Excavator',
    },
    {
        show: true,
        width: '400',
        sortable: false,
        filterable: false,
        field: 'dump_truck',
        title: 'Dump Truck',
    },
    {
        show: true,
        width: '220',
        sortable: false,
        filterable: false,
        field: 'modified_date',
        title: 'Modified Date',
        format: `${constants_1.formatGridDate.ddMMYYYY} ${constants_1.formatGridDate.hhMM}`
    },
    {
        show: true,
        width: '180',
        sortable: false,
        filterable: false,
        field: 'modified_by',
        title: 'Modified By',
    },
];
exports.OperatorAttendanceColumnFullWidthProps = OperatorAttendanceColumnFullWidthProps;
